import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { DISH_TYPES_QUERY } from '../graphql/queries'
import { FETCH_DISH_TYPES } from '../redux/action-types'
import { cleanupFetchDishTypes } from '../redux/actions'

const useDishTypesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchDishTypes)

  const { isLoading, error, initialData, latestEvent } = useSelector(
    store => store.dishTypes.dishTypes,
  )

  const refetch = useCallback(
    () => apolloService.query(DISH_TYPES_QUERY, {}, dispatch, FETCH_DISH_TYPES),

    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, initialData, latestEvent }
}

export default useDishTypesQuery
